<template>
<div class="yjtx">
  <div class="close" @click="closeyjtx">
    <img src="../../../assets/home/icon_close.png" alt="">
  </div>
  <div class="page1">
    <p><em>单位名称</em> <span>中国科技大学</span></p>
    <p><span class="pageTitle">检测点名称</span> <span class="pageTitle">隐患类型</span> <span class="pageTitle">隐患等级</span> </p>
    <p><span class="pageNr">科技楼</span> <span class="pageNr">严重短路</span> <span class="pageNr">较大隐患</span> <span class="pageNr"></span></p>
<!--    <p><em>检测名称:</em> <span>ssmm</span></p>
    <p><em><b>时</b><b>间:</b></em><span>2022年10月28日12时45分45秒</span></p>
    <p><em>设备状态: </em><span>运行正常</span></p>
    <p><em>地理位置: </em><span>上海市松江区广富林路568号松江万达</span></p>-->
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    closeyjtx() {
      this.$emit('opencqyj')
    }
  }
}
</script>

<style lang="scss" scoped>
.yjtx {
  background: url("../../../assets/home/item6_popbg1.png") no-repeat;
  width: 445px;
  height: 362px;
  background-size: 100% 100%;
  position: absolute;
  left: -3px;
  top: 50px;
  display: flex;
  z-index: 10;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: column;

  .close {
    width: 17px;
    height: 17px;
    position: absolute;
    right: 5px;
  }
}

.page1 {
  margin-left: 20px;
  padding-top: 30px;
  width: 100%;
  p {
    font-size: 18px;
    font-family: PingFang;
    font-weight: 500;
    color: rgba(#01A3FF, 0.6);
    line-height: 24px;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    flex-direction: row;
    align-content: flex-start;
    em {
      font-style: normal;
      margin-right: 10px;
      width: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;
    }

    span {
      font-size: 14px;
      font-family: PingFang;
      font-weight: 500;
      color: #CDF7FF;
    }
    .pageTitle {
      font-size: 18px;
      width: 25%;
    }
    .pageNr {
      font-size: 18px;
      width: 25%;
      a {
      }
    }
  }
}
</style>
